import filters from './filters'
export default{
  mixins: [filters],
  data(){
    return {
      objects: [],
      rel_object: null,
      selected_id2: null,
    }
  },
  computed: {
    first_choice(){
      return this.t('app.registration.select_create_choice', {type: this.form_block.name.toLowerCase()})
    },
    new_choice(){
      return this.t('app.registration.add_new', {type: this.form_block.name.toLowerCase()})
    },
    selected_title(){
      if (this.selected_id2 === -1){
        return this.new_choice;
      }else if(this.selected_id2){
        return this.objects.findById(this.selected_id2).opt_title;
      }else{
        return this.first_choice;
      }
    },
  },
  watch: {
    selected_id2(){
      // const setVal = this.selected_id2 === -1 ? null : this.selected_id2
      const obj = {id: this.selected_id2, ...this.objects.findById(this.selected_id2)}
      if (this.rfb) this.setRfb(this.rfb, obj)
      if (this.rfbs) for (const rfb of this.rfbs) this.setRfb(rfb, obj)
      // add custom fields
    }
  },
  methods: {
    setRfb(rfb, obj){
      rfb.entity_id = this.selected_id2
      if (!rfb.form_block) return
      const newObj = Object.fromEntries( [...rfb.form_block.attrs, "id"].map(attr=> [attr, obj[attr]]) )
      rfb.entity_attrs = newObj
    },
    r_form_block(form_block=this.form_block, main){
      return this.state.current_reg.find_rblock(form_block, main)
    },
    async relation_objects(form_block=this.form_block){
      let local_collection = []
      let rels             = []
      switch(form_block.style){
        case "Product::FormBlock::PartAddress":
          local_collection = this.dropVueCache( await this.$store.dispatch("reg_store/people_addresses") );
          rels             = this.state.current_reg.person.address_relations || [];

          this.rel_object = this.last_updated(rels.filter(rel=>rel.address_type===form_block.name));
          if (this.rel_object){
            this.rel_object.relation_id = this.rel_object.address_id
            this.rel_object.address_type = form_block.name
            for (let addr of local_collection){
              // addr.address_type = form_block.name
              if (this.rel_object && addr.id === this.rel_object.address_id && addr.updated_at_int < this.rel_object.updated_at_int){
                addr.updated_at_int = this.rel_object.updated_at_int
              }
            }
            this.selected_id2 = this.rel_object.relation_id
          }else{ //unset values on edit
            this.r_form_block().entity_id = null
            this.selected_id2 = null
          }
          form_block.connection_type = {type: "address_type", name: form_block.name}
          return this.objects = this.genTitles(this.filter_duplication_entities( local_collection, this.r_form_block().entity_id, 'address'),form_block)


        case "Product::FormBlock::PartParent":
        case "Product::FormBlock::PartParentContact":
        case "Product::FormBlock::PartParentWork":
          //
          local_collection = this.dropVueCache( await this.$store.dispatch("reg_store/people_family"));
          rels             = (this.state.current_reg.person.relations||[]).filter(rel=>rel.style==="Family");

          for (let ins of local_collection){
            ins.parent_relation_name = form_block.form_part.name
            let rel = rels.find(r=>ins.id===r.person_id);
            if (rel){
              if (ins.updated_at_int < rel.updated_at_int) ins.updated_at_int = rel.updated_at_int;
              for (let [k,v] of Object.entries(rel.options)) ins[k] = v
            }
          }

          this.rel_object = this.last_updated(rels.filter(rel=>rel.options.parent_relation_name===this.form_part.name));
          if (this.rel_object){
            this.rel_object.relation_id = this.rel_object.person_id;
            this.rel_object.parent_relation_name = form_block.form_part.name
            this.selected_id2 = this.rel_object.relation_id
          }else{ //unset values on edit
            this.r_form_block().entity_id = null
            this.selected_id2 = null
          }

          form_block.connection_type = {type: "parent_relation_name", name: form_block.form_part.name}
          return this.objects = this.genTitles(this.filter_duplication_entities( local_collection, this.r_form_block().entity_id, 'parent'),form_block)


        case "Product::FormBlock::PartParentAddress":
          let family_collection= await this.$store.dispatch("reg_store/people_family")
          local_collection = this.dropVueCache( await this.$store.dispatch("reg_store/people_addresses") );
          let parent = this.parent_entity_id ? family_collection.find(entity=>entity.id===this.parent_entity_id) : null

          if (parent){
            rels            = parent.address_relations||[];
            this.rel_object = this.last_updated(rels.filter(rel=>rel.address_type===form_block.name));
            if (this.rel_object){
              this.rel_object.relation_id  = this.rel_object.address_id
              this.rel_object.address_type = form_block.name
              for (let addr of local_collection){
                // addr.address_type = form_block.name
                if (this.rel_object && addr.id === this.rel_object.address_id && addr.updated_at_int < this.rel_object.updated_at_int){
                  addr.updated_at_int = this.rel_object.updated_at_int
                }
              }
              this.selected_id2 = this.rel_object.relation_id
            }
          }else{ //unset values on edit
            this.r_form_block().entity_id = null
            this.selected_id2 = null
          }
          form_block.connection_type = {type: "address_type", name: form_block.name}
          return this.objects = this.genTitles(this.filter_duplication_entities( local_collection, this.r_form_block().entity_id, 'address'),form_block)


        case "Product::FormBlock::PartDoctor":
          local_collection = this.dropVueCache( await this.$store.dispatch("reg_store/people_doctors") );
          rels             = (this.state.current_reg.person.relations||[]).filter(rel=>rel.style==="Doctor");

          for (let ins of local_collection){
            ins.doctor_type = form_block.name
            let rel = rels.find(r=>ins.id===r.person_id);
            if (rel){
              if (ins.updated_at_int < rel.updated_at_int) ins.updated_at_int = rel.updated_at_int;
              for (let [k,v] of Object.entries(rel.options)) ins[k] = v
            }
          }

          this.rel_object = this.last_updated(rels.filter(rel=>rel.options.doctor_type===form_block.name));
          if (this.rel_object){
            this.rel_object.relation_id = this.rel_object.person_id;
            this.rel_object.doctor_type = form_block.name
            this.selected_id2 = this.rel_object.relation_id
          }else{ //unset values on edit
            this.r_form_block().entity_id = null
            this.selected_id2 = null
          }

          form_block.connection_type = {type: "doctor_type", name: form_block.name}
          return this.objects = this.genTitles(this.filter_duplication_entities( local_collection, this.r_form_block().entity_id, 'doctors'),form_block)


        case "Product::FormBlock::PartEmergencyContact":
          local_collection = this.dropVueCache( await this.$store.dispatch("reg_store/people_emergencies") );
          rels             = (this.state.current_reg.person.relations||[]).filter(rel=>rel.style==="EmergencyContact");

          for (let ins of local_collection){
            ins.contact_type = form_block.name
            let rel = rels.find(r=>ins.id===r.person_id);
            if (rel){
              if (ins.updated_at_int < rel.updated_at_int) ins.updated_at_int = rel.updated_at_int;
              for (let [k,v] of Object.entries(rel.options)) ins[k] = v
            }
          }

          this.rel_object = this.last_updated(rels.filter(rel=>rel.options.contact_type===form_block.name));
          if (this.rel_object){
            this.rel_object.relation_id = this.rel_object.person_id;
            this.rel_object.contact_type = form_block.name
            this.selected_id2 = this.rel_object.relation_id
          }else{ //unset values on edit
            this.r_form_block().entity_id = null
            this.selected_id2 = null
          }

          form_block.connection_type = {type: "contact_type", name: form_block.name}
          this.objects = this.genTitles(this.filter_duplication_entities( local_collection, this.r_form_block().entity_id, 'emergency'),form_block)
          return this.objects

        case "Product::FormBlock::PartInsurance":
          local_collection = this.dropVueCache( await this.$store.dispatch("reg_store/people_insurances") );
          rels             = this.state.current_reg.person.insurance_relations||[];

          this.rel_object = this.last_updated(rels.filter(rel=>rel.insurance_type===null));
          if (this.rel_object){
            this.rel_object.relation_id = this.rel_object.insurance_id
            this.selected_id2 = this.rel_object.relation_id
            for (let ins of local_collection){
              if (this.rel_object && ins.id === this.rel_object.insurance_id && ins.updated_at_int < this.rel_object.updated_at_int){
                ins.updated_at_int = this.rel_object.updated_at_int
              }
            }
          }else{ //unset values on edit
            this.r_form_block().entity_id = null
            this.selected_id2 = null
          }
          return this.objects = this.genTitles(this.filter_duplication_entities( local_collection, this.r_form_block().entity_id, 'insurance'),form_block)
        // case "Product::FormBlock::PartPersonAcademicConcern":
        // case "Product::FormBlock::PartPersonConcern":
        // case "Product::FormBlock::PartPersonHeadConcern":
        // case "Product::FormBlock::PartPersonSpecialRequests":
        // case "Product::FormBlock::PartPersonAllergiesConcern":
        // case "Product::FormBlock::PartPersonCommunicableDiseasesConcern":
        // case "Product::FormBlock::PartPersonDevicesAccommodationsConcern":
        // case "Product::FormBlock::PartPersonFamilyHealthHistoryConcern":
        // case "Product::FormBlock::PartPersonGenderSpecificConcern":
        // case "Product::FormBlock::PartPersonInjuriesConcern":
        //   return this.objects = [await this.$store.dispatch("reg_store/person_concern")]
        // case "Product::FormBlock::PartMedication":
        //   return this.objects = await this.$store.dispatch("reg_store/people_medications") || []
        default:
          console.log("relation_objects not defined for ",form_block.style)
          return []
      }
    },

    async prefetchNew(what){
      if (this.selected_id2 !== -1) return

      const entity_id = this.r_form_block().entity_id
      const obj = (await this.$store.dispatch(what, false)).find(o=>o.id===entity_id)
      obj.opt_title = this.title(obj, this.form_block)
      this.objects.push(obj)
      this.selected_id2 = entity_id
    },

    genTitles(arr, form_block){
      for (const el of arr) el.opt_title = this.title(el, form_block)
      return arr
    },
    title(input, form_block) {
      if (!input || !input.id) return "";
      let name

      switch(form_block.style){
        case "Product::FormBlock::PartAddress":
        case "Product::FormBlock::PartParentAddress":
          name = [input.address_line1, input.city, input.state, input.zip_code].join(' ').trim()
          if (name.length === 0) name = "No name";
          return this.t('app.registration.entity_updated_with_date', {full_name: name, date: this.from_unix(input.updated_at_int) });
        case "Product::FormBlock::PartParent":
          name = [input.first_name, input.last_name].join(' ').trim()
          if(this.isPresent(input.email)) name += ", " + input.email
          return this.t('app.registration.entity_updated_with_date', {full_name: name, date: this.from_unix(input.updated_at_int) });
        case "Product::FormBlock::PartDoctor":
        case "Product::FormBlock::PartEmergencyContact":
          name = [input.first_name, input.last_name].join(' ').trim()
          return this.t('app.registration.entity_updated_with_date', {full_name: name, date: this.from_unix(input.updated_at_int) });
        case "Product::FormBlock::PartInsurance":
          name = [input.carrier, input.group_number].join(' ').trim()
          return this.t('app.registration.entity_updated_with_date', {full_name: name, date: this.from_unix(input.updated_at_int) });
        default:
          return "No logic for "+ form_block.style;
      }
    },
    dropVueCache(arr){
      return JSON.parse(JSON.stringify(arr))
    },
    last_updated(arr){
      return arr.sort((a, b) => b.updated_at_int - a.updated_at_int)[0]
    },
  }
}
